import React from 'react';
import Markup from "interweave";

const RelatedContentItem = ({item}) => (
  <div className="related--item">
    <div className="related--item--content padding__16 background__mist">
      { item.body !== '' && <Markup content={item.body} /> }
    </div>
    <div className="related--item--link">
      <a
        href={item.url}
        className="button__submit button__block">
        {item.title}
      </a>
    </div>
  </div>
);

export default RelatedContentItem;
